import { render, staticRenderFns } from "./LiveAutocomplete.vue?vue&type=template&id=4db81c14&"
import script from "./LiveAutocomplete.vue?vue&type=script&lang=js&"
export * from "./LiveAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAutocomplete,VBtn})
